import axios from 'axios';
import {
  DEFAULT_PARTNER_PID,
  DEFAULT_PARTNER_PASSWORD,
  RX_CARD_MAIL,
  RX_CARD_SMS,
  PRESC_CARD_MAIL,
  PRESC_CARD_SMS,
  RX_APP_PROMO,
  COOKIE_SIX_MONTH_EXPIRY_TIME
} from '../../../constants/defaults';
import _ from 'lodash';
import bffcli from '../bffcli';

const { API } = require('../../../config/' + process.env.REACT_APP_ENV);
export const mainAxios = axios.create({
  baseURL: API.SERVER,
  withCredentials: true
});
const errorHandler = err => {
  // TODO: Replace and add functionality of logger
  console.log(err);
};

const getUtmzData = () => {
  const utmzCookie = _.getCookie('_utmz_custom');
  const utmzCookies = utmzCookie.split('|');
  //Note : Sending null because API is responding with 400 if it is an empty string.
  const src = utmzCookies[2].split('=')[1] || null,
    med = utmzCookies[1].split('=')[1] || null,
    cgn = utmzCookies[0].split('=')[1] || null,
    msclkid =
      utmzCookies.find(item => item.includes('msclkid')).split('=')[1] || null,
    gclid = utmzCookies.find(item => item.includes('gclid')).split('=')[1];
  return {
    src,
    med,
    cgn,
    gclid,
    msclkid
  };
};

let apiInProgress = false;

export const createProspectContact = async isLoggedIn => {
  const activationContactCookie = _.getCookie('activation-contact');
  const prospectIdCookie = _.getCookie('prospect-id');
  const timezoneOffset = _.getCookie('timezone-offset');
  const { Ga4UserPsuedoId, Ga4SessionId } = _.getGATrackingParams();
  const { msclkid } = getUtmzData();
  const IsLoyaltyMember = isLoggedIn;
  if (
    (_.isEmpty(prospectIdCookie) || _.isEmpty(activationContactCookie)) &&
    !apiInProgress
  ) {
    try {
      apiInProgress = true;
      const couponData = await axios.post(
        `/api/service-contact/createProspect`,
        {
          IsLoyaltyMember: IsLoyaltyMember,
          timezoneOffset: timezoneOffset,
          Ga4UserPsuedoId: Ga4UserPsuedoId,
          Ga4SessionId: Ga4SessionId,
          msclkid: msclkid
        }
      );

      if (couponData.data && !_.isEmpty(couponData.data.Result)) {
        const { ContactId, MemberNumberFull, GroupNumber, ProspectId } =
          couponData.data.Result;

        _.setCookie(
          'activation-contact',
          `${ContactId}|${MemberNumberFull}|${GroupNumber}|${ProspectId}`,
          COOKIE_SIX_MONTH_EXPIRY_TIME
        );
        _.setCookie('prospect-id', ProspectId, COOKIE_SIX_MONTH_EXPIRY_TIME);
        apiInProgress = false;
        return {
          ContactId,
          MemberNumberFull,
          GroupNumber,
          ProspectId
        };
      }
    } catch (err) {
      apiInProgress = false;
      errorHandler(err);
    }
  } else {
    return { ProspectId: prospectIdCookie };
  }
};

export const fetchCouponData = async (
  pid = '',
  pPass = '',
  contactTypeId = '65',
  pdfParams = {},
  seoName = '',
  fullPrescriptionCost = '',
  loyaltyApplicable = '',
  loyaltyExcluded = '',
  bonusSavingsApplied = '',
  preferredNdc = '',
  isLoggedIn = false
) => {
  if (pid && pPass) {
    const { src, med, cgn, gclid, msclkid } = getUtmzData();
    const prospectId = _.getCookie('prospect-id');
    const timezoneOffset = _.getCookie('timezone-offset');
    const { Ga4UserPsuedoId, Ga4SessionId } = _.getGATrackingParams();

    let locale = window.location.href.includes('/es/') ? 'es-US' : 'en-US';
    let domain = location.host.includes('localhost')
      ? 'https://qa.singlecare.com'
      : window.location.origin;
    try {
      const data = {
        pid,
        pPass,
        contactTypeId,
        isLoggedIn,
        prospectId,
        pdfParams,
        src,
        med,
        cgn,
        timezoneOffset,
        locale,
        domain,
        seoName,
        fullPrescriptionCost,
        loyaltyApplicable,
        loyaltyExcluded,
        bonusSavingsApplied: bonusSavingsApplied ? bonusSavingsApplied : '0.00',
        gclid,
        Ga4UserPsuedoId,
        Ga4SessionId,
        msclkid,
        preferredNdc
      };
      const couponData = await axios.post(
        `/api/service-contact/fetchCouponContact`,
        data,
        { withCredentials: true }
      );

      if (couponData) {
        return couponData.data.Result;
      }
    } catch (err) {
      errorHandler(err);
    }
  }
};

export const newFetchCouponData = async (
  pid = '',
  pPass = '',
  contactTypeId = '65',
  pdfParams = {},
  seoName = '',
  fullPrescriptionCost = '',
  loyaltyApplicable = '',
  loyaltyExcluded = '',
  bonusSavingsApplied = '',
  isLoggedIn = false
) => {
  if (pid && pPass) {
    const { src, med, cgn, gclid, msclkid } = getUtmzData();
    const prospectId = _.getCookie('prospect-id');
    const timezoneOffset = _.getCookie('timezone-offset');
    const { Ga4UserPsuedoId, Ga4SessionId } = _.getGATrackingParams();

    const IsLoyaltyMember = isLoggedIn;
    let locale = window.location.href.includes('/es/') ? 'es-US' : 'en-US';
    let domain = location.host.includes('localhost')
      ? 'https://qa.singlecare.com'
      : window.location.origin;
    try {
      const data = {
        pid,
        pPass,
        contactTypeId,
        isLoggedIn,
        prospectId,
        pdfParams,
        src,
        med,
        cgn,
        IsLoyaltyMember,
        timezoneOffset,
        locale,
        domain,
        seoName,
        fullPrescriptionCost,
        loyaltyApplicable,
        loyaltyExcluded,
        bonusSavingsApplied: bonusSavingsApplied ? bonusSavingsApplied : '0.00',
        gclid,
        Ga4UserPsuedoId,
        Ga4SessionId,
        msclkid
      };
      const couponData = await bffcli.post(
        `/service-contact/newfetchCouponContact`,
        data,
        { withCredentials: true }
      );

      if (couponData) {
        return couponData.data.Result;
      }
    } catch (err) {
      errorHandler(err);
      return err;
    }
  }
};

export const sendCouponToMedia = async (
  pid = '',
  pPass = '',
  drugName = '',
  pharmacyName = '',
  drugForm = '',
  dosage = '',
  quantity = '',
  price = '',
  type = '',
  typeId = '',
  isRxCard = false,
  seoName = '',
  fullPrescriptionCost = '',
  loyaltyApplicable = '',
  loyaltyExcluded = '',
  bonusSavingsApplied = '',
  loyaltyDiscountType = '',
  loyaltyDiscountAmount = '',
  preferredNdc = ''
) => {
  try {
    const timezoneOffset = _.getCookie('timezone-offset');
    const { src, med, cgn, gclid, msclkid } = getUtmzData();
    const { Ga4UserPsuedoId, Ga4SessionId } = _.getGATrackingParams();
    let locale = window.location.href.includes('/es/') ? 'es-US' : 'en-US';
    let domain = window.location.origin;
    let contactTypeId = type === 'Email' ? RX_CARD_MAIL : RX_CARD_SMS;
    if (!isRxCard) {
      contactTypeId = type === 'Email' ? PRESC_CARD_MAIL : PRESC_CARD_SMS;
    }
    const noRxCardData = {
      drugName,
      pharmacyName,
      drugForm,
      dosage,
      quantity,
      price,
      seoName,
      fullPrescriptionCost,
      loyaltyApplicable,
      loyaltyExcluded,
      bonusSavingsApplied: bonusSavingsApplied ? bonusSavingsApplied : '0.00',
      loyaltyDiscountType,
      loyaltyDiscountAmount
    };
    const data = {
      isRxCard,
      type,
      typeId,
      pid,
      pPass,
      contactTypeId,
      src,
      med,
      cgn,
      timezoneOffset,
      locale,
      domain,
      gclid,
      ...(!isRxCard && { ...noRxCardData }),
      Ga4UserPsuedoId,
      Ga4SessionId,
      msclkid,
      preferredNdc
    };
    const couponData = await axios.post(
      `/api/service-contact/sendCouponContact`,
      data
    );
    if (couponData) {
      return couponData;
    }
  } catch (err) {
    errorHandler(err);
  }
};

export const newSendCouponToMedia = async (
  pid = '',
  pPass = '',
  drugName = '',
  pharmacyName = '',
  drugForm = '',
  dosage = '',
  quantity = '',
  price = '',
  type = '',
  typeId = '',
  isRxCard = false,
  seoName = '',
  fullPrescriptionCost = '',
  loyaltyApplicable = '',
  loyaltyExcluded = '',
  bonusSavingsApplied = '0.0',
  loyaltyDiscountType = '',
  loyaltyDiscountAmount = '0.0',
  isUserLogin = false,
  ndc = '',
  preferredNdc = ''
) => {
  try {
    const timezoneOffset = _.getCookie('timezone-offset');
    const { src, med, cgn, gclid, msclkid } = getUtmzData();
    const { Ga4UserPsuedoId, Ga4SessionId } = _.getGATrackingParams();
    const IsLoyaltyMember = !_.isPublicView();
    let locale = window.location.href.includes('/es/') ? 'es-US' : 'en-US';
    let domain = location.host.includes('localhost')
      ? 'https://qa.singlecare.com'
      : window.location.origin;
    let contactTypeId = type === 'Email' ? RX_CARD_MAIL : RX_CARD_SMS;
    if (!isRxCard) {
      contactTypeId = type === 'Email' ? PRESC_CARD_MAIL : PRESC_CARD_SMS;
    }
    const noRxCardData = {
      drugName,
      ndc,
      pharmacyName,
      drugForm,
      dosage,
      quantity,
      price,
      seoName,
      fullPrescriptionCost,
      loyaltyApplicable,
      loyaltyExcluded,
      bonusSavingsApplied: bonusSavingsApplied ? bonusSavingsApplied : '0.00',
      loyaltyDiscountType,
      loyaltyDiscountAmount: !_.isEmpty(loyaltyDiscountAmount)
        ? loyaltyDiscountAmount
        : '0.00'
    };
    const data = {
      isRxCard,
      type,
      typeId,
      pid,
      pPass,
      contactTypeId,
      src,
      med,
      cgn,
      IsLoyaltyMember,
      timezoneOffset,
      locale,
      domain,
      gclid,
      isUserLogin,
      ...(!isRxCard && { ...noRxCardData }),
      Ga4UserPsuedoId,
      Ga4SessionId,
      msclkid,
      preferredNdc
    };
    const couponData = await axios.post(
      `/api/service-contact/newSendCouponContact`,
      data
    );
    if (couponData) {
      return couponData;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};

export const sendAppPromoContact = async (phone, isLoggedIn = false) => {
  const timezoneOffset = _.getCookie('timezone-offset');
  const IsLoyaltyMember = isLoggedIn;
  let locale = window.location.href.includes('/es/') ? 'es-US' : 'en-US';
  let domain = window.location.origin;
  const { cgn, gclid, msclkid } = getUtmzData();
  const { Ga4UserPsuedoId, Ga4SessionId } = _.getGATrackingParams();
  try {
    const data = {
      pid: DEFAULT_PARTNER_PID,
      pPass: DEFAULT_PARTNER_PASSWORD,
      contactTypeId: RX_APP_PROMO,
      phone,
      cgn,
      IsLoyaltyMember,
      timezoneOffset,
      locale,
      domain,
      gclid,
      Ga4UserPsuedoId,
      Ga4SessionId,
      msclkid
    };

    const couponData = await axios.post(
      `/api/service-contact/sendAppPromoContact`,
      data
    );
    if (couponData) {
      return couponData;
    }
  } catch (err) {
    errorHandler(err);
  }
};

export const downloadFile = imgsrc => {
  try {
    axios({
      url: imgsrc,
      method: 'GET',
      withCredentials: true,
      responseType: 'blob' // important
    }).then(response => {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: 'image/png' })
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 's3download.png');
      document.body.appendChild(link);
      link.click();
    });
  } catch (err) {
    errorHandler(err);
  }
};

export const createContact = async (data, getStatusCode) => {
  const {
    email,
    address,
    addressOptional,
    zipCode,
    city,
    state,
    firstName,
    lastName,
    pid,
    pPass,
    pharmacy
  } = data;

  const { src, med, cgn, gclid, msclkid } = getUtmzData();
  const { Ga4UserPsuedoId, Ga4SessionId } = _.getGATrackingParams();
  let contactTypeId = 81;
  try {
    apiInProgress = true;

    const dataAPI = {
      pid,
      pPass,
      contactTypeId,
      src,
      med,
      cgn,
      email,
      address,
      addressOptional,
      zipCode,
      city,
      state,
      firstName,
      lastName,
      pharmacy,
      gclid,
      Ga4UserPsuedoId,
      Ga4SessionId,
      msclkid
    };
    const physicalCardData = await axios.post(
      `/api/service-contact/createPhysicalCardContact`,
      dataAPI
    );
    if (physicalCardData) {
      return physicalCardData;
    }
  } catch (err) {
    getStatusCode(err && err.response && err.response.status);
    errorHandler(err);
  } finally {
    apiInProgress = false;
  }
};

export const newCreateContact = async (data, getStatusCode) => {
  const {
    email,
    address,
    addressOptional,
    zipCode,
    city,
    state,
    firstName,
    lastName,
    pid,
    pPass,
    pharmacy
  } = data;

  const { src, med, cgn, gclid, msclkid } = getUtmzData();
  const { Ga4UserPsuedoId, Ga4SessionId } = _.getGATrackingParams();
  let contactTypeId = 81;
  try {
    apiInProgress = true;

    const dataAPI = {
      pid,
      pPass,
      contactTypeId,
      src,
      med,
      cgn,
      email,
      address,
      addressOptional,
      zipCode,
      city,
      state,
      firstName,
      lastName,
      pharmacy,
      gclid,
      Ga4UserPsuedoId,
      Ga4SessionId,
      msclkid
    };
    const physicalCardData = await axios.post(
      `/api/service-contact/newCreatePhysicalCardContact`,
      dataAPI
    );
    if (physicalCardData) {
      return physicalCardData;
    }
  } catch (err) {
    getStatusCode(err && err.response && err.response.status);
    errorHandler(err);
  } finally {
    apiInProgress = false;
  }
};

export const addressValidation = async (data, getStatusCode) => {
  try {
    const addressValidationData = await axios.post(
      `/api/service-contact/address`,
      data
    );
    if (addressValidationData) {
      return addressValidationData;
    }
  } catch (err) {
    getStatusCode(err && err.response && err.response.status);
    errorHandler(err);
  } finally {
    apiInProgress = false;
  }
};

export const addToWallet = async data => {
  try {
    const utmData = getUtmzData();
    const addToWalletResp = await bffcli.post(`/addToWallet`, {
      ...data,
      ...utmData
    });
    if (addToWalletResp) {
      return addToWalletResp?.data;
    }
  } catch (err) {
    errorHandler(err);
  }
};
